import { fromRational, Maybe, Money } from "@flockcover/flock-svc-core-types"

const moneyToString = (money: Maybe<Money> | null, locale = `en`): string => {
  if (money === null) return ``

  const formatter = new Intl.NumberFormat(locale, {
    style: `currency`,
    currency: money.currency,
  })

  return formatter.format(fromRational(money.value))
}

export default moneyToString
